<template lang="html">

<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: sketchtool 51.3 (57544) - http://www.bohemiancoding.com/sketch -->
    <title>8DA72F09-1A02-4C3D-9FCC-6F43F644A137</title>
    <desc>Created with sketchtool.</desc>
    <defs></defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="04a-mi-cv" transform="translate(-927.000000, -2609.000000)" :stroke="colors.basic" stroke-width="1.8">
            <g id="documentación" transform="translate(42.000000, 2610.000000)">
                <g id="add" transform="translate(886.000000, 0.000000)">
                    <circle id="Oval-4" fill-rule="nonzero" cx="11" cy="11" r="11"></circle>
                    <path d="M11,6 L11,16" id="Stroke-3" stroke-linejoin="round"></path>
                    <path d="M16,11 L6,11" id="Stroke-3-Copy" stroke-linejoin="round"></path>
                </g>
            </g>
        </g>
    </g>
</svg>

</template>

<script lang="js">
  
  import {mapGetters} from 'vuex';

  export default  {
    name: 'add',
    props: [],
    computed : {
      ...mapGetters({
        colors : 'basicColors'
      })
    }
}
</script>

<style scoped lang="scss">
  .add {

  }
</style>



// WEBPACK FOOTER //
// submodules/dotia-base-fp/src/components/parts/icons/add.vue